function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.442 1.502a5.19 5.19 0 00-7.289 0l-10.02 9.92a3.799 3.799 0 000 5.412c1.244 1.232 3.121 1.431 4.589.632a.642.642 0 00.42-.18l10.022-9.92a2.532 2.532 0 000-3.608 2.595 2.595 0 00-3.644 0l-8.199 8.117a.634.634 0 000 .902.65.65 0 00.911 0l8.2-8.117a1.296 1.296 0 011.82 0 1.265 1.265 0 010 1.803l-9.565 9.47a2.594 2.594 0 01-3.644 0 2.532 2.532 0 010-3.606l10.021-9.923a3.892 3.892 0 015.467 0 3.8 3.8 0 010 5.411l-9.11 9.02a.634.634 0 000 .901.65.65 0 00.91 0l9.11-9.019a5.066 5.066 0 000-7.215z"
})));